import { dispatch } from "hf-rt";

const initialState = {
  enlargeActive: false,
  enlargeImageUrl: ""
};

export default {
  name: "enlargeImage",
  actions: {
    showEnlargeImage: img => {
      dispatch({ type: "SHOW_ENLARGE_IMAGE", img });
    },
    closeEnlargeImage: () => {
      dispatch({ type: "CLOSE_ENLARGE_IMAGE" });
    }
  },
  reducers: function(state = initialState, action) {
    switch (action.type) {
      case "SHOW_ENLARGE_IMAGE":
        return {
          ...state,
          enlargeActive: true,
          enlargeImageUrl: action.img
        };
      case "CLOSE_ENLARGE_IMAGE":
        return {
          ...state,
          enlargeActive: false
        };
      default:
        return state;
    }
  }
};
